// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lead-management {
  padding: 20px;
  background: #f5f6fa;
  min-height: 100vh;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #e0e0e0;
}

.page-header h1 {
  font-size: 28px;
  color: #2c3e50;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 10px;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 15px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.stat-icon {
  font-size: 40px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 10px;
}

.stat-details h3 {
  font-size: 28px;
  color: #2c3e50;
  margin: 0 0 5px 0;
}

.stat-details p {
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
}

/* Filters */
.filters-section {
  background: white;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.search-input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  width: 100%;
}

.filters-section select {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  background: white;
  cursor: pointer;
}

/* Table */
.table-container {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.data-table th {
  padding: 15px 12px;
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.data-table td {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
}

.data-table tbody tr:hover {
  background: #f8f9fa;
}

.no-data {
  text-align: center;
  padding: 40px !important;
  color: #999;
  font-style: italic;
}

/* Status Badges */
.status-badge,
.stage-badge {
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
}

.badge-new { background: #3498db; color: white; }
.badge-followup { background: #f39c12; color: white; }
.badge-hot { background: #e74c3c; color: white; }
.badge-cold { background: #95a5a6; color: white; }
.badge-converted { background: #27ae60; color: white; }
.badge-lost { background: #c0392b; color: white; }
.badge-dead { background: #34495e; color: white; }
.badge-meeting { background: #9b59b6; color: white; }
.badge-not-picked-up { background: #f1c40f; color: white; }
.badge-not-interested { background: #7f8c8d; color: white; }
.badge-interested { background: #2ecc71; color: white; }
.badge-switch-off { background: #d35400; color: white; }
.badge-invalid { background: #7f8c8d; color: white; }
.badge-busy { background: #e67e22; color: white; }
.badge-call-cut { background: #c0392b; color: white; }
.badge-default { background: #bdc3c7; color: white; }

.stage-inquiry { background: #ecf0f1; color: #2c3e50; }
.stage-demo { background: #d4edda; color: #155724; }
.stage-negotiation { background: #fff3cd; color: #856404; }
.stage-booking { background: #cce5ff; color: #004085; }
.stage-closed { background: #c3e6cb; color: #155724; }
.stage-lost { background: #f8d7da; color: #721c24; }
.stage-default { background: #e2e3e5; color: #383d41; }

.assigned-employee {
  color: #27ae60;
  font-weight: 600;
}

.unassigned {
  color: #e74c3c;
  font-style: italic;
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  padding: 5px;
  transition: transform 0.2s;
}

.btn-icon:hover {
  transform: scale(1.2);
}

.btn-view {
  color: #3498db;
}

.btn-view:hover {
  color: #2980b9;
}

.btn-edit {
  color: #f39c12;
}

.btn-edit:hover {
  color: #e67e22;
}

.btn-assign {
  color: #27ae60;
}

.btn-assign:hover {
  color: #229954;
}

.btn-delete {
  color: #e74c3c;
}

.btn-delete:hover {
  color: #c0392b;
}

/* Buttons */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.btn-success {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
}

.btn-success:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(56, 239, 125, 0.4);
}

.btn-secondary {
  background: #95a5a6;
  color: white;
}

.btn-secondary:hover {
  background: #7f8c8d;
}

.btn-danger {
  background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
  color: white;
}

.btn-danger:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 75, 43, 0.4);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow-y: auto;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 15px;
  max-width: 900px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.assign-modal {
  max-width: 500px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  border-bottom: 2px solid #f0f0f0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 15px 15px 0 0;
}

.modal-header h2 {
  margin: 0;
  font-size: 24px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 32px;
  color: white;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 32px;
  height: 32px;
  transition: transform 0.2s;
}

.close-btn:hover {
  transform: rotate(90deg);
}

/* Form */
.lead-form {
  padding: 25px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 14px;
  font-family: inherit;
  transition: border-color 0.3s;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.assign-form {
  padding: 25px;
}

.assign-info {
  background: #e8f4fd;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  color: #2c3e50;
  font-weight: 600;
  text-align: center;
}

/* Loading */
.loading {
  text-align: center;
  padding: 40px;
  font-size: 16px;
  color: #7f8c8d;
}

.table-container {
  overflow-x: auto;
  width: 100%;
  border-radius: 8px;
}

/* Responsive */
@media (max-width: 1200px) {
  .filters-section {
    grid-template-columns: 1fr 1fr;
  }
  
  .search-input {
    grid-column: 1 / -1;
  }
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
  
  .filters-section {
    grid-template-columns: 1fr;
  }
  
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .table-container {
    overflow-x: auto;
  }
}

/* Modal Tab Styles for Lead Creation */
.modal-tabs {
  display: flex;
  background: #f0f2f5;
  border-bottom: 2px solid #e2e8f0;
  padding: 10px 25px 0 25px;
}

.modal-tab-btn {
  background: none;
  border: none;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 600;
  color: #718096;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
}

.modal-tab-btn:hover {
  color: #4a5568;
}

.modal-tab-btn.active {
  color: #667eea;
}

.modal-tab-btn.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 3px;
  background: #667eea;
  border-radius: 3px 3px 0 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/LeadManagement.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,WAAW;EACX,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA,aAAa,mBAAmB,EAAE,YAAY,EAAE;AAChD,kBAAkB,mBAAmB,EAAE,YAAY,EAAE;AACrD,aAAa,mBAAmB,EAAE,YAAY,EAAE;AAChD,cAAc,mBAAmB,EAAE,YAAY,EAAE;AACjD,mBAAmB,mBAAmB,EAAE,YAAY,EAAE;AACtD,cAAc,mBAAmB,EAAE,YAAY,EAAE;AACjD,cAAc,mBAAmB,EAAE,YAAY,EAAE;AACjD,iBAAiB,mBAAmB,EAAE,YAAY,EAAE;AACpD,uBAAuB,mBAAmB,EAAE,YAAY,EAAE;AAC1D,wBAAwB,mBAAmB,EAAE,YAAY,EAAE;AAC3D,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;AACvD,oBAAoB,mBAAmB,EAAE,YAAY,EAAE;AACvD,iBAAiB,mBAAmB,EAAE,YAAY,EAAE;AACpD,cAAc,mBAAmB,EAAE,YAAY,EAAE;AACjD,kBAAkB,mBAAmB,EAAE,YAAY,EAAE;AACrD,iBAAiB,mBAAmB,EAAE,YAAY,EAAE;;AAEpD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;AACtD,gBAAgB,mBAAmB,EAAE,cAAc,EAAE;AACrD,cAAc,mBAAmB,EAAE,cAAc,EAAE;AACnD,iBAAiB,mBAAmB,EAAE,cAAc,EAAE;;AAEtD;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,0BAA0B;AAC5B","sourcesContent":[".lead-management {\n  padding: 20px;\n  background: #f5f6fa;\n  min-height: 100vh;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #e0e0e0;\n}\n\n.page-header h1 {\n  font-size: 28px;\n  color: #2c3e50;\n  margin: 0;\n}\n\n.header-actions {\n  display: flex;\n  gap: 10px;\n}\n\n/* Stats Grid */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 30px;\n}\n\n.stat-card {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.stat-icon {\n  font-size: 40px;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f0f0f0;\n  border-radius: 10px;\n}\n\n.stat-details h3 {\n  font-size: 28px;\n  color: #2c3e50;\n  margin: 0 0 5px 0;\n}\n\n.stat-details p {\n  font-size: 14px;\n  color: #7f8c8d;\n  margin: 0;\n}\n\n/* Filters */\n.filters-section {\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 15px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.search-input {\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n  width: 100%;\n}\n\n.filters-section select {\n  padding: 10px 15px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n  background: white;\n  cursor: pointer;\n}\n\n/* Table */\n.table-container {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.data-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.data-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.data-table th {\n  padding: 15px 12px;\n  text-align: left;\n  font-weight: 600;\n  font-size: 14px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.data-table td {\n  padding: 12px;\n  border-bottom: 1px solid #f0f0f0;\n  font-size: 14px;\n  color: #333;\n}\n\n.data-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.no-data {\n  text-align: center;\n  padding: 40px !important;\n  color: #999;\n  font-style: italic;\n}\n\n/* Status Badges */\n.status-badge,\n.stage-badge {\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n\n.badge-new { background: #3498db; color: white; }\n.badge-followup { background: #f39c12; color: white; }\n.badge-hot { background: #e74c3c; color: white; }\n.badge-cold { background: #95a5a6; color: white; }\n.badge-converted { background: #27ae60; color: white; }\n.badge-lost { background: #c0392b; color: white; }\n.badge-dead { background: #34495e; color: white; }\n.badge-meeting { background: #9b59b6; color: white; }\n.badge-not-picked-up { background: #f1c40f; color: white; }\n.badge-not-interested { background: #7f8c8d; color: white; }\n.badge-interested { background: #2ecc71; color: white; }\n.badge-switch-off { background: #d35400; color: white; }\n.badge-invalid { background: #7f8c8d; color: white; }\n.badge-busy { background: #e67e22; color: white; }\n.badge-call-cut { background: #c0392b; color: white; }\n.badge-default { background: #bdc3c7; color: white; }\n\n.stage-inquiry { background: #ecf0f1; color: #2c3e50; }\n.stage-demo { background: #d4edda; color: #155724; }\n.stage-negotiation { background: #fff3cd; color: #856404; }\n.stage-booking { background: #cce5ff; color: #004085; }\n.stage-closed { background: #c3e6cb; color: #155724; }\n.stage-lost { background: #f8d7da; color: #721c24; }\n.stage-default { background: #e2e3e5; color: #383d41; }\n\n.assigned-employee {\n  color: #27ae60;\n  font-weight: 600;\n}\n\n.unassigned {\n  color: #e74c3c;\n  font-style: italic;\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.btn-icon {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  padding: 5px;\n  transition: transform 0.2s;\n}\n\n.btn-icon:hover {\n  transform: scale(1.2);\n}\n\n.btn-view {\n  color: #3498db;\n}\n\n.btn-view:hover {\n  color: #2980b9;\n}\n\n.btn-edit {\n  color: #f39c12;\n}\n\n.btn-edit:hover {\n  color: #e67e22;\n}\n\n.btn-assign {\n  color: #27ae60;\n}\n\n.btn-assign:hover {\n  color: #229954;\n}\n\n.btn-delete {\n  color: #e74c3c;\n}\n\n.btn-delete:hover {\n  color: #c0392b;\n}\n\n/* Buttons */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);\n  color: white;\n}\n\n.btn-success:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(56, 239, 125, 0.4);\n}\n\n.btn-secondary {\n  background: #95a5a6;\n  color: white;\n}\n\n.btn-secondary:hover {\n  background: #7f8c8d;\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);\n  color: white;\n}\n\n.btn-danger:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(255, 75, 43, 0.4);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Modal */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 15px;\n  max-width: 900px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.assign-modal {\n  max-width: 500px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 25px;\n  border-bottom: 2px solid #f0f0f0;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 15px 15px 0 0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 24px;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 32px;\n  color: white;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  transition: transform 0.2s;\n}\n\n.close-btn:hover {\n  transform: rotate(90deg);\n}\n\n/* Form */\n.lead-form {\n  padding: 25px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 8px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: border-color 0.3s;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding-top: 20px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.assign-form {\n  padding: 25px;\n}\n\n.assign-info {\n  background: #e8f4fd;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  color: #2c3e50;\n  font-weight: 600;\n  text-align: center;\n}\n\n/* Loading */\n.loading {\n  text-align: center;\n  padding: 40px;\n  font-size: 16px;\n  color: #7f8c8d;\n}\n\n.table-container {\n  overflow-x: auto;\n  width: 100%;\n  border-radius: 8px;\n}\n\n/* Responsive */\n@media (max-width: 1200px) {\n  .filters-section {\n    grid-template-columns: 1fr 1fr;\n  }\n  \n  .search-input {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .stats-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .filters-section {\n    grid-template-columns: 1fr;\n  }\n  \n  .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 15px;\n  }\n  \n  .table-container {\n    overflow-x: auto;\n  }\n}\n\n/* Modal Tab Styles for Lead Creation */\n.modal-tabs {\n  display: flex;\n  background: #f0f2f5;\n  border-bottom: 2px solid #e2e8f0;\n  padding: 10px 25px 0 25px;\n}\n\n.modal-tab-btn {\n  background: none;\n  border: none;\n  padding: 12px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #718096;\n  cursor: pointer;\n  position: relative;\n  transition: color 0.2s;\n}\n\n.modal-tab-btn:hover {\n  color: #4a5568;\n}\n\n.modal-tab-btn.active {\n  color: #667eea;\n}\n\n.modal-tab-btn.active::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: #667eea;\n  border-radius: 3px 3px 0 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
